import { Textarea as GlucoseTextarea } from '@signavio/ui/core';
import { utils } from '../../styles';
import { useStyles } from '@signavio/ui';
import { jsx as _jsx } from "react/jsx-runtime";
const Textarea = ({
  style = {},
  readOnly,
  ...rest
}) => {
  const styles = useStyles(textareaStyles, {
    style
  }, {
    '&readOnly': Boolean(readOnly)
  });
  return /*#__PURE__*/_jsx(GlucoseTextarea, {
    style: styles,
    ...rest
  });
};
const textareaStyles = theme => ({
  ...utils.input(theme),
  display: 'block',
  resize: 'vertical',
  width: '100%'
});
export default Textarea;